import { type Href, Redirect, router } from 'expo-router';
import { useEffect, useState } from 'react';
import { ActivityIndicator, View } from 'react-native';

import { fetchFamilyRootId } from '@/lib/blocks/api';
import { getLastPageId } from '@/lib/navigation/last-page';

export default function AppHomeScreen() {
  const [target, setTarget] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function resolveLandingPage(): Promise<void> {
      try {
        const last = await getLastPageId();
        if (last) {
          if (!cancelled) {
            setTarget(`/page/${last}`);
          }
          return;
        }
        const familyId = await fetchFamilyRootId();
        if (familyId && !cancelled) {
          setTarget(`/page/${familyId}`);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    void resolveLandingPage();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (target) {
      router.replace(target as Href);
    }
  }, [target]);

  if (loading) {
    return (
      <View className="min-h-full flex-1 items-center justify-center bg-surface">
        <ActivityIndicator size="large" />
      </View>
    );
  }

  if (!target) {
    return <Redirect href="/settings" />;
  }

  return (
    <View className="min-h-full flex-1 items-center justify-center bg-surface">
      <ActivityIndicator size="large" />
    </View>
  );
}
